import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { TailSpin } from 'react-loading-icons';

const LoaderModal = ({ loading }) => {
  return (
    <Modal
      title=""
      visible={loading}
      width={500}
      footer={null}
      preserve={false}
      closable={false}
      centered
      zIndex={100000}
    >
      <div className="flex justify-center">
        <h5 className="text-h5 text-text font-bold ml-2">
          <TailSpin fill="#E89178" stroke="#E89178" height={50} />
        </h5>
      </div>
    </Modal>
  );
};

LoaderModal.propTypes = {
  loading: PropTypes.bool,
};

export default LoaderModal;
